import { style, media } from 'typestyle'
import { important } from 'csx'
export const mt8mdi = style(media({ maxWidth: 768 }, { marginTop: important('8px') }))
